import React, { createContext, useContext, useEffect, useState } from "react";

const PartnerContext = createContext({
  loading: true,
  partner: null,
  displayConfig: {},
  logoUrl: null,
  appName: "CrunchAlpha",
  tagline: "Risk-Controlled Copy Trading",
});

export function PartnerProvider({ children }) {
  const [state, setState] = useState({
    loading: true,
    partner: null,
    displayConfig: {},
    logoUrl: null,
    appName: "CrunchAlpha",
    tagline: "Risk-Controlled Copy Trading",
  });

  useEffect(() => {
    let cancelled = false;

    fetch("/api/partner/config")
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;

        const p = data && data.partner ? data.partner : null;

        if (p) {
          if (p.primaryColor) {
            document.documentElement.style.setProperty("--accent", p.primaryColor);
          }
          if (p.faviconUrl) {
            const link = document.querySelector("link[rel~='icon']");
            if (link) link.href = p.faviconUrl;
          }
        }

        setState({
          loading: false,
          partner: p,
          displayConfig: p && p.displayConfig ? p.displayConfig : {},
          logoUrl: p && p.logoUrl ? p.logoUrl : null,
          appName: p && p.displayName ? p.displayName : "CrunchAlpha",
          tagline: p ? (p.tagline || "") : "Risk-Controlled Copy Trading",
        });
      })
      .catch(() => {
        if (!cancelled) {
          setState((prev) => ({ ...prev, loading: false }));
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return <PartnerContext.Provider value={state}>{children}</PartnerContext.Provider>;
}

export function usePartner() {
  return useContext(PartnerContext);
}